import { ValidatorFn, Validators } from '@angular/forms';
import { EAGLESOFT_PASSWORD_MIN_LENGTH, eaglesoftPasswordPatterns, multiPatternValidator } from '@libs/utils';

export const eaglesoftPasswordModalValidators: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(EAGLESOFT_PASSWORD_MIN_LENGTH),
  multiPatternValidator(eaglesoftPasswordPatterns({ requireSpecialChar: true })),
];

export { eaglesoftPasswordMatchValidator as eaglesoftPasswordModalMatchValidator } from '@libs/utils';
